
































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { ROUTER_NAME } from '../../router'
import Exam from '../../models/exam'
import { checkMobile } from '../../utils/utils'
import ExamStatusForm from '../../../api/v2/forms/answer_status'
import { LETTER_FORMAT } from '../../utils/constants'
import QuestionGroupTestList from '../atoms_molecules/QuestionGroupTestList.vue'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import { examTestState } from '../../stores/exam_test'

@Component({
  components: {
    QuestionGroupTestList
  }
})
export default class ExamTestQuestionList extends Vue {
  get exam(){
    return examTestState.exam
  }
  get redirectNotFoundPage(){
    return examTestState.redirectNotFoundPage
  }

  get groupExamTestQuestions(){
    return examTestState.groupExamTestQuestions
  }

  get userExam(){
    if (!this.userExamId) {
      return this.exam.userExam
    }

    const userExam = this.exam.userExams.find(item => item.id == parseInt(this.userExamId as string))
    return userExam
  }
  get userExamId(){
    return this.$route.query['user_exam_id']
  }

  getQuestionNumber(groupExamTestQuestion){
    return this.groupExamTestQuestions.filter(
      item => item.questions.every(question => !question.isDescriptionQuestion)
    ).indexOf(groupExamTestQuestion) + 1
  }

  get answeredCount(){
    return examTestState.examTestQuestionsAnswered.length
  }
  get testQuestionCount(){
    return examTestState.examTestIgnoreDescription.length
  }

  LETTER_FORMAT = LETTER_FORMAT
  mobile = checkMobile()

  @Watch('exam')
  changeExam(val) {
    this.updateData(val, this.$route)
  }

  @Watch('$route', {immediate: true})
  changeRoute(val) {
    examTestState.requestExamTest(parseInt(this.$route.params.examId)).then(()=>{
      examTestState.setUserExamId(this.userExam.id)
      examTestState.getExamTestQuestions()
    })
  }
  redirectToExamList() {
    this.$router.push({
      name: ROUTER_NAME.MY_EXAM_LIST
    })
  }

  updateData(exam: Exam, route) {
    if (exam && exam.isDone(this.userExam) && this.userExam.isWaitingScoreCheck) {
      this.redirectToExamList()
      return
    }
    if (exam && exam.questions) {
      if (this.userExam.finishedAt) {
        this.redirectToExamResult()
      }
    }
    if (this.mobile) {
      headerState.setTitle(this.$t('question.answer_number', {
          format: LETTER_FORMAT.UPTITLECASE
        }) +
        ' ' +
        exam.answersFlowQuestion.length +
        '/' +
        exam.questionsIgnoreDescription.length)
    }
  }

  @Watch('redirectNotFoundPage')
  changeRedirectNotFoundPage(val) {
    if (val) {
      examTestState.setRedirectNotFoundPage({ status: false })
      this.redirectToNotFoundPage()
    }
  }

  redirectToNotFoundPage() {
    this.$router.push({
      name: ROUTER_NAME.NOT_FOUND
    })
  }

  redirectToExamResult() {
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: this.$route.params.examId
      },
      query: {
        user_exam_id: this!.userExam.id.toString()
      },
    })
  }

  public mounted() {
    if (this.mobile) {
      footerState.setFooter({
        color: '#f7931e',
        show: true,
        default: {
          show: false
        },
        buttons: {
          show: true,
          items: [
            {
              icon: 'angle-double-left',
              round: false,
              color: 'white',
              action: this.backQuestion
            },
            {
              icon: 'angle-left',
              round: false,
              color: 'white',
              action: this.last
            },
            {
              icon: '',
              round: true,
              color: 'white',
              label: this.$t('common.submit', {
                format: LETTER_FORMAT.UPPERCASE
              }) as string,
              action: this.showResult
            },
            {
              icon: '',
              round: false,
              color: 'white'
            },
            {
              icon: '',
              round: false,
              color: 'white'
            }
          ]
        }
      })
    } else {
      footerState.setFooterDefault()
    }
  }

  backQuestion() {
    window.history.back()
  }

  async showResult() {
    const examStatusForm = new ExamStatusForm()
    examStatusForm.examId = this.exam!.id
    examStatusForm.isFinishExam = true
    examStatusForm.userExamId = this.userExam.id
    await examTestState.saveExamStatus({ examStatusForm })
    this.redirectToExamResult()
  }

  last() {
    var qsId = this.exam!.userExam.questions[this.exam!.userExam.questions.length - 1].id
    this.$router.push({
      name: ROUTER_NAME.QUESTION,
      params: {
        examId: this.$route.params.examId,
        questionId: qsId.toString()
      },
      query: this.$route.query
    })
  }

  goQuestion(questionId: number) {
    if (questionId != parseInt(this.$route.params.questionId)) {
      this.$router.push({
        name: ROUTER_NAME.QUESTION,
        params: {
          examId: `${this.exam!.id}`,
          questionId: `${questionId}`
        },
        query: this.$route.query
      })
    }
  }
}
